import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import './Backend.css';
import { useAuth } from '../../contexts/AuthContext';

const Backend = () => {
    const [userData, setUserData] = useState({});
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const { currentUser, getProfileData: authGetProfileData } = useAuth();
    
    const getProfileData = async () => {
      try {
        setIsAuthLoading(true);
        const res = await authGetProfileData();
        
        if (res && res.success && res.data) {
          setUserData(res.data);
        } else {
          // Fallback to Firebase user data
          if (currentUser) {
            const userData = {
              id: currentUser.uid,
              name: currentUser.displayName || currentUser.email,
              email: currentUser.email,
              images: currentUser.photoURL || '',
              first_name: currentUser.displayName?.split(' ')[0] || '',
              last_name: currentUser.displayName?.split(' ')[1] || ''
            };
            setUserData(userData);
          }
        }
      } catch (error) {
        console.error("Error getting profile data:", error);
        // Fallback to Firebase user data
        if (currentUser) {
          const userData = {
            id: currentUser.uid,
            name: currentUser.displayName || currentUser.email,
            email: currentUser.email,
            images: currentUser.photoURL || '',
            first_name: currentUser.displayName?.split(' ')[0] || '',
            last_name: currentUser.displayName?.split(' ')[1] || ''
          };
          setUserData(userData);
        }
      } finally {
        setIsAuthLoading(false);
      }
    }
    useEffect(() => {
      getProfileData();
      return () => {
        console.log("cleanup")
      }
    }, []);
    if (isAuthLoading) {
      return (
        <div className="backendWrap">
          <div className="loading-spinner-container">
            <div className="loading-spinner"></div>
          </div>
        </div>
      );
    }

    return (
    <>
    <div className="backendWrap">
      <Header userData={userData}/>
      <Outlet context={[userData, currentUser]}/>                                     
    </div>
    </>
    )
  };
  
  export default Backend;
  